import { BrowserRouter, Route, Routes } from "react-router-dom";
import Home from "./layouts/Home";
import Recipes from "./layouts/Recipes";
import SingleRecipe from "./layouts/SingleRecipe";
import Error from "./layouts/Error";

function App() {
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home/>} />
          <Route path="/recipes" exact element={<Recipes active='Food' open='recipes'/>} />
          <Route path="/recipes/appetizer" exact element={<Recipes active='Appetizers' open='category'/>} />
          <Route path="/recipes/meat" exact element={<Recipes active='Non-Veg' open='category'/>} />
          <Route path="/recipes/drinks" exact element={<Recipes active='Drinks' open='category'/>} />
          <Route path="/recipes/desserts" exact element={<Recipes active='Desserts' open='category'/>} />
          <Route path="/recipes/mainDish" exact element={<Recipes active='Main Courses' open='category'/>} />
          <Route path="/recipes/cereals" exact element={<Recipes active='Cereals' open='category'/>} />
          <Route path="/recipe/:id" exact element={<SingleRecipe/>} />
          <Route path="/search/recipes/:id" exact element={<Recipes active='Search' open='recipes'/>} />
          <Route path="/expert/recipes/:id" exact element={<Recipes active='Expert Food' open='recipes'/>} />
          <Route path="/*" element={<Error/>} />
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
